import { useState } from "react";
import ButtonSpinLoader from "../Components/ButtonLoader/ButtonSpinLoader";
import styled from "styled-components";
import { useLanguage } from "../Components/LangTranslation/LanguageContext";
import { useSession } from "../authentications/SessionContext";
import { primaryColor } from "../utilities/colors";

const Button = styled.button`
  background-color: #f8f9fa;
  color: #b0b7c3;
  width: 280px;
  min-width: 160px;
  border: none;
  border-radius: 15px;
  padding: 10px 20px;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 600;

  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  &:hover,
  &:focus,
  &:active {
    background-color: ${(props) =>
      props["data-isvtex"] ? "#000000" : "#ff5837"};
    color: ${(props) =>
      props["data-isvtex"] ? primaryColor.primary : "#ffffff"};
  }
`;

function useFormikSubmitButton() {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const FormikSubmitButtons = ({ handleCloseModal }) => {
    return (
      <div className="d-flex flex-column flex-md-row justify-content-md-end justify-content-center mt-5 mb-3 gap-3">
        <Button onClick={handleCloseModal} data-isvtex={isVTEX}>
          {t["Cancel"]}
        </Button>
        <Button
          disabled={isSubmitting}
          type="submit"
          className="save-button position-relative d-flex justify-content-center align-items-center"
          data-isvtex={isVTEX}
        >
          <ButtonSpinLoader isLoading={isSubmitting} />
          {t["Save"]}
        </Button>
      </div>
    );
  };
  return {
    isSubmitting,
    setIsSubmitting,
    FormikSubmitButtons,
  };
}

export default useFormikSubmitButton;
